const decodeHtml = (html) => {
    if (html == null) return '';
    if (typeof html !== 'string') return String(html);
    
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
};

export default decodeHtml;
